package org.vreo.devicehub.features.core.domain.device.device

import kotlinx.datetime.LocalDateTime
import com.benasher44.uuid.uuid4

/**
 * Anpr device model
 *
 * @property id item/object id. Used for identification for kotlin and ui operations.
 * @property deviceId device id provided by data source
 * @property device device/product type
 * @property serialNumber serial number
 * @property softwareVersion software version
 * @property ocrVersion ocr version
 * @property localIpAddress device's local network ip address
 * @property macAddress device's MAC address
 * @property active connection status
 * @property lastActivityTime last activity time
 * @property userTag device owner tag, allows user to add name/tag to device
 * @property linkinPassword device access password, allows user to link device to account
 * @property primaryConnectionKey device connection string, allows device to connect to IoT provider.
 */
data class AnprDevice(
    val id: Int = uuid4().hashCode(),
    val deviceId: String,
    val device: ProductType,
    val serialNumber: String,
    val softwareVersion: String,
    val ocrVersion: String,
    val localIpAddress: String,
    val macAddress: String,
    val active: Boolean,
    val lastActivityTime: LocalDateTime? = null,
    val userTag: String? = null,
    val linkinPassword: String? = null,
    val primaryConnectionKey: String? = null
)

